import { MenuPoint } from '@agilox/ui-common';
import { analyticsMenuPoints } from './analytics-menupoints';

export const desktopMenuPoints: MenuPoint[] = [
	analyticsMenuPoints.aiInsights,
	analyticsMenuPoints.dashboard,
	analyticsMenuPoints.processes,
	analyticsMenuPoints.failures,
	analyticsMenuPoints.help,
	analyticsMenuPoints.logout,
];
